import axios from 'axios'
import endpoints from '../configuration/endpoints'

export const REQUEST_STATE_OPTIONS = 'REQUEST_STATE_OPTIONS'
export const RECEIVE_STATE_OPTIONS = 'RECEIVE__STATE_OPTIONS'
export const STATE_OPTIONS_ERROR = 'STATE_OPTIONS_ERROR'

export const requestStateOptions = countryList => dispatch => {
  dispatch({
    type: REQUEST_STATE_OPTIONS
  })

  const promises = countryList.map(country =>
    axios.get(endpoints.countries + country)
  )

  const states = []

  Promise.all(promises)
    .then(values => {
      values.forEach(val => {
        states.push(...val.data.data.division)
      })
      dispatch({
        type: RECEIVE_STATE_OPTIONS,
        payload: states
      })
    })
    .catch(() => {
      dispatch({
        type: STATE_OPTIONS_ERROR
      })
    })
}
